import { render, staticRenderFns } from "./across_template.vue?vue&type=template&id=5f1d9498&scoped=true"
import script from "./across_template.vue?vue&type=script&lang=js"
export * from "./across_template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d9498",
  null
  
)

export default component.exports